module.exports = __webpack_public_path__ + "483542b28ace01ac47887b1ea9dc93ba.pdf";